import { render, staticRenderFns } from "./SpeakerList2.vue?vue&type=template&id=704b23b6&scoped=true&"
import script from "./SpeakerList2.vue?vue&type=script&lang=js&"
export * from "./SpeakerList2.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerList2.vue?vue&type=style&index=0&id=704b23b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b23b6",
  null
  
)

export default component.exports